var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100",attrs:{"id":"notification-page"}},[_c('NotificationComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }